// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"101":"1bd17c31","109":"cef2bb72","154":"b98b7bfc","343":"c19f2bcf","395":"8c29c931","642":"48ab273b","850":"b86a5824","858":"e1075fff","904":"2cab67ca","973":"07b9c595"}[chunkId] + ".chunk.js";
};